import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useSupportListStyles = makeStyles(
  (theme: Theme) => {
    const isDark = theme.palette.mode === 'dark';

    const labelText = {
      color: isDark ? 'var(--xlrt-color-ui-white)' : '#35363A',
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '155%',
    };

    return {
      popoverPaper: {
        width: '17.5rem',
        borderRadius: '0.5rem',
        background: isDark ? '#383838' : '#F7F8F8',
        border: isDark
          ? '1px solid var(--xlrt-color-ui-gray40)'
          : '1px solid #E1E3E5',
        boxShadow: 'none',
      },
      contentContainer: {
        display: 'flex',
        padding: '0.75rem',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '0.75rem',
        alignSelf: 'stretch',

        '& .headerSection': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '0.5rem',
          alignSelf: 'stretch',

          '& .title': {
            ...labelText,
            fontWeight: 500,
          },

          '& .description': {
            ...labelText,
            color: isDark ? 'var(--xlrt-color-ui-gray85)' : '#74757E',
          },
        },
      },
      listContainer: {
        padding: 0,
        width: '100%',
      },
      listItem: {
        display: 'flex',
        padding: '0.75rem 0.5rem',
        gap: '0.5rem',
        alignItems: 'center',
        alignSelf: 'stretch',

        '&:hover': {
          borderRadius: '0.5rem',
          background: isDark ? '#4D4D4D' : '#E9EBEC',
        },
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',

        '& .listItemIcon': {
          minWidth: '1.5rem',
          color: isDark ? 'var(--xlrt-color-ui-white)' : '#35363A',

          '& .v5-MuiSvgIcon-root': {
            fontSize: '1.25rem',
          },
        },

        '& .listItemText': {
          margin: 0,

          '& .v5-MuiTypography-root': {
            ...labelText,
            lineHeight: '133%',
            letterSpacing: '-0.168px',
          },
        },
      },
    };
  },
  { name: 'SupportList' },
);
